import { render, staticRenderFns } from "./PurchaseHistoryTable.vue?vue&type=template&id=34a53192&"
import script from "./PurchaseHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports